import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import HomePage from './pages/HomePage'
import AdminPage from './pages/AdminPage'

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <HomePage />
          </Layout>
        }
      />
      {/* صفحهٔ مدیریت — بدون هدر/فوتر، فقط داشبورد */}
      <Route path="/admin" element={<AdminPage />} />
      {/* هر مسیر دیگر → صفحهٔ اصلی */}
      <Route
        path="*"
        element={
          <Layout>
            <HomePage />
          </Layout>
        }
      />
    </Routes>
  )
}

export default App
